const SeminarDetailsLoading = () => {
    return (
        <div>
            <div className="h-10 w-full l-load mb-3"></div>
            <div className="w-full rounded-md h-[22rem] max-lg:h-[18rem] flex justify-center items-center relative l-load">
                <div className=" h-10 rounded-lg absolute w-[28rem] -bottom-5 z-20 max-lg:w-9/12 l-load-dt"></div>
            </div>
            {/* CONTENT OF COACH LOADING */}
            <div className=" p-3 my-5 flex justify-between items-start max-lg:flex-col max-lg:gap-4 l-load">
                <div className="flex items-start gap-4 max-md:flex-col ">
                    <div className="size-32 rounded-md l-load-dt"></div>
                    <ul className="space-y-3">
                        <li className="w-40 h-4 rounded l-load-dt"></li>
                        <li className="w-32 h-4 rounded l-load-dt"></li>
                        <li className="w-28 h-4 rounded l-load-dt"></li>
                        <li className="w-36 h-4 rounded l-load-dt"></li>
                        <li className="w-44 h-4 rounded l-load-dt"></li>
                    </ul>
                </div>

                <div className="rounded-md relative w-6/12 pt-5 max-lg:w-full mt-4">
                    <div className="flex gap-2 items-center mb-4 absolute flex-wrap -top-6 right-0 max-lg:gap-1">
                        {[...Array(4)].map((_, i) => (
                            <div key={i} className="w-24 h-8 rounded-lg l-load-dt"></div>
                        ))}
                    </div>
                    <div className="w-full h-24 rounded l-load-dt"></div>
                </div>
            </div>
        </div>
    )
};
export default SeminarDetailsLoading